<template>
  <div class="reset-page">
    <div class="bg-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
    </div>

    <div class="card">
      <div class="card-top">
        <div class="brand-icon">
          <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
            <circle cx="17" cy="17" r="15" stroke="#a78bfa" stroke-width="2" opacity="0.3"/>
            <path d="M11 17L14.5 20.5L23 12" stroke="#a78bfa" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M17 6V11" stroke="#a78bfa" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/>
            <path d="M17 23V28" stroke="#a78bfa" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/>
          </svg>
        </div>
        <h1 class="brand-name">重置密码</h1>
        <p class="brand-desc">验证身份后重设登录密码</p>
      </div>

      <div class="steps">
        <div class="step-item" :class="{ active: step >= 1, done: step > 1 }">
          <div class="step-circle">
            <svg v-if="step > 1" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M3.5 7L6 9.5L10.5 4.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span v-else>1</span>
          </div>
          <span class="step-label">验证身份</span>
        </div>
        <div class="step-line" :class="{ active: step > 1 }"></div>
        <div class="step-item" :class="{ active: step >= 2 }">
          <div class="step-circle"><span>2</span></div>
          <span class="step-label">重置密码</span>
        </div>
      </div>

      <template v-if="step === 1">
        <div class="form-body">
          <div class="input-group">
            <label class="input-label">手机号</label>
            <div class="input-wrap">
              <van-field
                v-model="userphone"
                clearable
                type="number"
                placeholder="请输入手机号"
                input-class="field-input"
                maxlength="11"
              />
            </div>
          </div>

          <div class="input-group">
            <label class="input-label">短信验证码</label>
            <div class="input-wrap input-wrap-code">
              <van-field
                v-model="smscode"
                clearable
                type="number"
                placeholder="输入验证码"
                input-class="field-input"
                maxlength="6"
              >
                <template #button>
                  <button
                    class="code-btn"
                    :class="{ 'code-btn--disabled': countdown > 0 }"
                    :disabled="countdown > 0 || !userphone"
                    @click="sendsmscode"
                  >
                    {{ countdown > 0 ? countdown + 's' : '获取验证码' }}
                  </button>
                </template>
              </van-field>
            </div>
          </div>
        </div>

        <button class="submit-btn" @click="nextStep" :disabled="!userphone || !smscode">
          下一步
        </button>
      </template>

      <template v-if="step === 2">
        <div class="form-body">
          <div class="input-group">
            <label class="input-label">新密码</label>
            <div class="input-wrap">
              <van-field
                v-model="userpassword"
                :type="showPwd ? 'text' : 'password'"
                clearable
                placeholder="6-20位字母或数字"
                input-class="field-input"
                :right-icon="showPwd ? 'eye-o' : 'closed-eye'"
                @click-right-icon="showPwd = !showPwd"
              />
            </div>
          </div>

          <div class="input-group">
            <label class="input-label">确认新密码</label>
            <div class="input-wrap">
              <van-field
                v-model="reuserpassword"
                :type="showRePwd ? 'text' : 'password'"
                clearable
                placeholder="再次输入新密码"
                input-class="field-input"
                :right-icon="showRePwd ? 'eye-o' : 'closed-eye'"
                @click-right-icon="showRePwd = !showRePwd"
              />
            </div>
          </div>
        </div>

        <button class="submit-btn" @click="resetPassword" :disabled="loading">
          <span v-if="!loading">重置密码</span>
          <span v-else class="btn-loading"></span>
        </button>
      </template>

      <div class="back-row">
        <span @click="gotologin">返回登录</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'passwordreset',
  data() {
    return {
      userphone: '',
      userpassword: '',
      reuserpassword: '',
      smscode: '',
      showPwd: false,
      showRePwd: false,
      loading: false,
      countdown: 0,
      timer: null,
      step: 1
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    gotologin() { this.$router.push({ name: 'login' }) },
    sendsmscode() {
      if (this.countdown > 0) return;
      if (!this.userphone || this.userphone.length < 11) {
        this.$toast.fail('请输入正确的手机号');
        return;
      }
      const qs = require('qs');
      this.$axios.post('/api/user/sms', qs.stringify({ 'phone': this.userphone }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.$toast.success('获取短信验证码成功');
            this.countdown = 60;
            this.timer = setInterval(() => {
              this.countdown--;
              if (this.countdown <= 0) {
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          } else if (response.data.error_code === 202) {
            this.$toast.fail('图形验证码错误！');
          } else if (response.data.error_code === 205) {
            this.$toast.fail('短信已发送，获取短信间隔过短！');
          } else {
            this.$toast.fail('获取短信验证码失败！');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    nextStep() {
      if (!this.userphone || !this.smscode) {
        this.$toast.fail('请填写完整信息');
        return;
      }
      this.step = 2;
    },
    resetPassword() {
      if (!this.userpassword || !this.reuserpassword) {
        this.$toast.fail('请填写密码');
        return;
      }
      if (this.userpassword !== this.reuserpassword) {
        this.$toast.fail('2次密码输入不一致！');
        return;
      }
      this.loading = true;
      const qs = require('qs');
      this.$axios.post('/api/user/change_password', qs.stringify({
        'password': this.userpassword,
        'repassword': this.reuserpassword,
        'sms_check': this.smscode
      }))
        .then((response) => {
          this.loading = false;
          if (response.data.error_code === 0) {
            this.$toast.success('密码重置成功');
            setTimeout(() => {
              this.$router.push({ path: '/', name: '设备主页', query: { gid: [''] } });
            }, 800);
          } else if (response.data.error_code === 201) {
            this.$toast.fail('此手机号已经被注册！');
          } else if (response.data.error_code === 206) {
            this.$toast.fail('短信验证码错误！');
          }
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    }
  }
}
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Noto+Sans+SC:wght@400;500;600;700&display=swap");
</style>

<style scoped>
.reset-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(145deg, #eef2ff 0%, #f0f9ff 40%, #faf5ff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
  font-family: "Inter", "Noto Sans SC", sans-serif;
  position: relative;
  overflow: hidden;
}

.bg-shapes {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.shape {
  position: absolute;
  border-radius: 50%;
}

.shape-1 {
  width: 280px;
  height: 280px;
  background: radial-gradient(circle, rgba(167, 139, 250, 0.1) 0%, transparent 70%);
  top: -60px;
  left: -60px;
  animation: shapeDrift 18s ease-in-out infinite alternate;
}

.shape-2 {
  width: 320px;
  height: 320px;
  background: radial-gradient(circle, rgba(99, 102, 241, 0.06) 0%, transparent 70%);
  bottom: -80px;
  right: -60px;
  animation: shapeDrift 20s ease-in-out infinite alternate-reverse;
}

.shape-3 {
  width: 180px;
  height: 180px;
  background: radial-gradient(circle, rgba(45, 212, 191, 0.05) 0%, transparent 70%);
  top: 20%;
  right: -30px;
  animation: shapeDrift 16s ease-in-out infinite alternate;
}

.shape-4 {
  width: 160px;
  height: 160px;
  background: radial-gradient(circle, rgba(251, 191, 36, 0.04) 0%, transparent 70%);
  bottom: 20%;
  left: -30px;
  animation: shapeDrift 22s ease-in-out infinite alternate-reverse;
}

@keyframes shapeDrift {
  0% { transform: translate(0, 0) scale(1); }
  100% { transform: translate(20px, -15px) scale(1.08); }
}

.card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 400px;
  background: #ffffff;
  border-radius: 28px;
  padding: 36px 32px 32px;
  box-shadow: 0 4px 32px rgba(0, 0, 0, 0.04), 0 20px 60px rgba(0, 0, 0, 0.06);
  animation: cardSlide 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes cardSlide {
  from { opacity: 0; transform: translateY(24px); }
  to { opacity: 1; transform: translateY(0); }
}

.card-top {
  text-align: center;
  margin-bottom: 24px;
}

.brand-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.brand-name {
  font-weight: 700;
  font-size: 22px;
  color: #1e293b;
  margin: 0 0 4px;
  letter-spacing: 0.5px;
}

.brand-desc {
  font-size: 13px;
  color: #94a3b8;
  margin: 0;
  font-weight: 400;
}

.steps {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 28px;
}

.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.step-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  font-family: "Inter", sans-serif;
  transition: all 0.3s;
  background: #f1f5f9;
  color: #94a3b8;
}

.step-item.active .step-circle {
  background: rgba(167, 139, 250, 0.15);
  color: #a78bfa;
  box-shadow: 0 0 0 3px rgba(167, 139, 250, 0.15);
}

.step-item.done .step-circle {
  background: #a78bfa;
  color: #fff;
}

.step-label {
  font-size: 11px;
  color: #94a3b8;
  font-weight: 500;
  transition: color 0.3s;
}

.step-item.active .step-label,
.step-item.done .step-label {
  color: #64748b;
}

.step-line {
  width: 52px;
  height: 2px;
  background: #e2e8f0;
  margin: 0 10px;
  margin-bottom: 22px;
  border-radius: 1px;
  transition: background 0.3s;
}

.step-line.active {
  background: #a78bfa;
}

.form-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.input-label {
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  padding-left: 2px;
}

.input-wrap :deep(.van-cell) {
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 14px;
  padding: 10px 16px;
  transition: border-color 0.25s, box-shadow 0.25s, background 0.25s;
  min-height: 46px;
}

.input-wrap :deep(.van-cell:focus-within) {
  border-color: #a78bfa;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(167, 139, 250, 0.08);
}

.input-wrap :deep(.van-field__body) {
  background: transparent;
}

.field-input {
  color: #1e293b !important;
  font-size: 15px !important;
  font-weight: 500 !important;
  background: transparent !important;
}

.input-wrap :deep(.van-field__placeholder) {
  color: #cbd5e1 !important;
  font-weight: 400 !important;
}

.input-wrap :deep(.van-field__right-icon) {
  color: #94a3b8;
  font-size: 18px;
}

.input-wrap-code :deep(.van-cell) {
  padding-right: 4px;
}

.code-btn {
  flex-shrink: 0;
  height: 36px;
  padding: 0 16px;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  background: linear-gradient(135deg, #a78bfa, #8b5cf6);
  color: #fff;
  transition: opacity 0.2s, transform 0.15s;
  font-family: inherit;
}

.code-btn:active {
  transform: scale(0.95);
}

.code-btn--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.submit-btn {
  display: block;
  width: 100%;
  height: 50px;
  border: none;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 3px;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%);
  box-shadow: 0 4px 16px rgba(167, 139, 250, 0.3);
  transition: transform 0.2s, box-shadow 0.2s;
  margin-bottom: 18px;
  font-family: inherit;
}

.submit-btn:active:not(:disabled) {
  transform: scale(0.97);
  box-shadow: 0 2px 8px rgba(167, 139, 250, 0.25);
}

.submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-loading {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.back-row {
  text-align: center;
}

.back-row span {
  font-size: 14px;
  color: #a78bfa;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.2s;
}

.back-row span:active {
  color: #7c3aed;
}
</style>
